var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeDeclare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 21,
    viewBox: "0 0 40 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3454 10.4721L17.3278 15.4429L13.7428 18.9944C13.0789 19.6545 12.1785 20.0252 11.2398 20.0252C10.301 20.0252 9.40066 19.6545 8.73673 18.9944L0 10.3058L5.00651 5.32727L11.24 11.5264L12.3126 10.4601L17.3235 5.47769L22.3454 10.4721Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 4.97853L25.9088 18.9936C25.2448 19.6536 24.3445 20.0244 23.4057 20.0244C22.4669 20.0244 21.5666 19.6536 20.9027 18.9936L12.3125 10.4592L17.3234 5.47681L23.406 11.5255L34.994 0L40.0001 4.97853Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.2888,
    y1: 10.3787,
    x2: 7.40017,
    y2: 23.2898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5D79",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.9068,
    y1: 20.0862,
    x2: -1.17379,
    y2: 20.0862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5D79",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeDeclare);
export default __webpack_public_path__ + "static/media/WeDeclare.c0bff992.svg";
export { ForwardRef as ReactComponent };